import { deleteApi, getApi, patchApi, postApi } from '../utils/api'

export function getContacts({ entityId, model, options, params }) {
  return getApi({
    endpoint: 'api/contact/list/',
    options,
    params: { ...params, fk: entityId, model },
  })
}

export function createContact({ data, options }) {
  return postApi({
    data,
    endpoint: 'api/contact/',
    options,
  })
}

export function editContact({ data, id, model, options }) {
  return patchApi({
    data,
    endpoint: `api/contact/${id}/`,
    options,
    params: { model },
  })
}

export function deleteContact({ id, model, options }) {
  return deleteApi({
    data: { id, model },
    endpoint: `api/contact/${id}/`,
    options,
  })
}
